module.exports = __webpack_public_path__ + "img/au.503a3a98.svg";